module.exports = __webpack_public_path__ + "img/adameva02.bf029118.svg";